export enum SogButtonType{
  Default,
  Card,
  Toolbar,
  Appbar
}
